<p-sidebar
  #sideBar
  [(visible)]="visible"
  [dismissible]="dismissable"
  [position]="sidebarPosition | lowercase"
  [fullScreen]="sidebarFullscreen"
  [styleClass]="(sidebarPosition | lowercase) + ' ' + sidebarStyleClass"
  appendTo="body"
  (visibleChange)="onVisibleChange(sideBar)"
(onHide)="onHide()">
  <ng-template [pTemplate]="headless ? 'headless' : 'content'">
    <div class="wrapper overflow-auto" [ngClass]="{ 'p-4 pt-0': headless }" [style]="{ width: this.width }">
      <ng-content></ng-content>
    </div>
  </ng-template>
</p-sidebar>
